export default {"src":"/_next/static/media/icon_player_crown.bf1a3d99.svg","height":25,"width":29,"blurWidth":0,"blurHeight":0};